// eslint-disable-next-line no-shadow
enum WebsocketStatus {
  CONNECTING = 'CONNECTING',
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export default WebsocketStatus;
